export default function AboutValues() {
  const values = [
    {
      icon: 'ri-eye-line',
      title: 'Şeffaflık',
      desc: 'Tüm kampanya performanslarını gerçek zamanlı dashboard ve aylık detaylı raporlarla müşterilerimizle paylaşıyoruz. Gizli maliyet, gizli strateji yok.',
    },
    {
      icon: 'ri-bar-chart-2-line',
      title: 'Veri Odaklılık',
      desc: 'Her kararı veriyle alırız. A/B testleri, ısı haritası analizi, kullanıcı davranışı izleme ve dönüşüm hunisi optimizasyonuyla sürekli iyileştiririz.',
    },
    {
      icon: 'ri-award-line',
      title: 'Sonuç Garantisi',
      desc: 'Sadece "güzel" kampanyalar yapmıyoruz. KPI\'ları önceden belirler, sözleşmeli hedeflere ulaşmayı taahhüt ederiz. Ölçülebilir ROI odaklı çalışırız.',
    },
    {
      icon: 'ri-lightbulb-flash-line',
      title: 'Yaratıcılık',
      desc: 'Veri stratejisini yaratıcı fikirlerle birleştiririz. Markanızın sesini en etkileyici şekilde duyurur, rakiplerinizden farklılaşmanızı sağlarız.',
    },
    {
      icon: 'ri-team-line',
      title: 'İşbirliği',
      desc: 'Müşterimizin ekibinin bir parçası gibi çalışırız. Haftalık ilerleme toplantıları, anlık Slack/Teams iletişimi ve stratejik danışmanlık sunarız.',
    },
    {
      icon: 'ri-speed-line',
      title: 'Agresif Büyüme',
      desc: 'Yavaş ve güvenli değil, hızlı ve etkili büyüme hedefleriz. Her kanalda maksimum verimlilik için sürekli optimizasyon yaparız.',
    },
  ];

  return (
    <section className="section-padding bg-background-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mb-10 md:mb-14 text-center">
          <p className="text-primary-500 font-bold text-sm tracking-[0.2em] uppercase mb-2">
            ILKELERIMIZ
          </p>
          <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl text-foreground-50 tracking-tighter mb-4">
            DEĞERLERIMIZ
          </h2>
          <p className="text-sm md:text-base text-foreground-400 max-w-xl mx-auto">
            Biff Digital'i sektörde farklı kılan 6 temel değer. Her projede bu ilkeler ışığında hareket ederiz.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {values.map((v, idx) => (
            <div key={idx} className="glass-card-hover rounded-2xl p-6 md:p-7 group">
              <div className="w-12 h-12 bg-primary-500/10 rounded-xl flex items-center justify-center mb-4 group-hover:bg-primary-500/20 transition-colors">
                <i className={`${v.icon} text-xl text-primary-500`} />
              </div>
              <h3 className="text-lg md:text-xl font-bold text-foreground-50 mb-2">
                {v.title}
              </h3>
              <p className="text-sm text-foreground-400 leading-relaxed">
                {v.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}